/**
 * Created by jayasudha.selvaraj on 10/11/2016.
 */
quoteModule.controller('rvVehicleDefinitionController',
    ['$scope','$rootScope', '$window', 'vehicleDefinitionService', 'quoteCreationEvents','$q','rateQuoteCoordService',
        'welcomeEvents', 'tuxFabMenuEvents', 'rateQuoteRetrievalCoordService','ListItemSetup','quoteInitializationService',
        'contractCreationService','quoteIntegrationConstants','erateSessionVarsService', 'vehicleProductsProcessingService',
        'dealerPreferencesService','TLCError','AppErrorCodes','vehicleTypeConstants',
        function ($scope, $rootScope, $window, vehicleDefinitionService, quoteCreationEvents, $q, rateQuoteCoordService,
                  welcomeEvents, tuxFabMenuEvents, rateQuoteRetrievalCoordService, ListItemSetup,quoteInitializationService,
                  contractCreationService, quoteIntegrationConstants, erateSessionVarsService, vehicleProductsProcessingService,
                  dealerPreferencesService, TLCError, AppErrorCodes, vehicleTypeConstants) {

            /*
             The vehicle controller keeps track of the year/make/model and vin "explosion" information for the quote. Anytime we change
             the vehicle attributes (date of sale, odometer, whatever), we need to signal that we should clear anything
             existing, and re-retrieve products.

             We also integrate with external pages to grab the vehicle information. Usually this consists of the VIN, date of
             sale, and odometer.

             We can also retrieve the vehicle information from an existing quote.
             */
            var self = this;
            //initialize the directive with the controller
            this.init = function(element){
                self.$element = element;
            }

            $scope.rvContractProcessing = contractCreationService.contractsProcessing;
            $scope.rvQuoteMode = null;
            $scope.rvMenuQuoteIntegrated = quoteIntegrationConstants.menuQuoteIntegrated;
            $scope.rvMenuContractIntegrated = quoteIntegrationConstants.menuContractIntegrated;

            $scope.valTOWABLE ='TOWABLE';
            $scope.valMOTORHOME = 'MOTORHOME';
            //vehicle definition object (in scope)
            $scope.rvVehicleDefinition = {
                modelYearSetup: new ListItemSetup("modelyear"),
                vehicleUsageSetup: new ListItemSetup("vehicleusage"),
                vehiclePlanTypeSetup: new ListItemSetup("plantype"),
                prevRVType: "",
                prevVIN: "",
                prevOdometer: "",
                prevyear: "",
                prevmakeId: "",
                prevmodelId: "",
                prevUsage: "",
                dealInfoChanged: false,
                makeName: "",
                modelName: "",
                prevManuMonths: "",
                prevManuMiles: "",
                rvType: $scope.valMOTORHOME
            };

            $scope.rvHoldYear = "";
            $scope.rvHoldMake = null;
            $scope.rvHoldModel = null;
            $scope.rvVehicleData = {};
            $scope.newRVGUID = null;
            $scope.rvSupportedVehicleType = vehicleTypeConstants.rv;
            $scope.providerUsagesByVin = false;
            //initialization
            $scope.rvInitializeDetails = function(){
                $scope.providerUsagesByVin = vehicleDefinitionService.providerHasUsagesByVIN();
                $scope.rvVehicleData = rateQuoteCoordService.VehicleData;
                $scope.rvGetVehicleModelYears();
                $scope.rvGetVehicleSaleTypes();
                if ($scope.providerUsagesByVin) {
                    //at the moment we arent' REALLY getting by VIN/odo
                    $scope.rvGetVehicleVinUsages();
                } else {
                    $scope.rvGetVehicleUsages();
                }
                $scope.rvQuoteMode = erateSessionVarsService.getQuotingMode();
                quoteInitializationService.signalChildReady('vehicleReady');
                $scope.newRVGUID = null;
            };

            $scope.rvUpdateSaleType = function(){
                rateQuoteRetrievalCoordService.endQuoteRetrieval();
                $scope.rvGetCurrentVehicleInfo();
            };

            $scope.updateRVType = function(){
                rateQuoteRetrievalCoordService.endQuoteRetrieval();
                $scope.rvGetCurrentVehicleInfo();
                hasVehicleChanged();
            };

            //starting a new quote
            $scope.$on(quoteCreationEvents.startNewProductQuote, function(event, args) {
                if (rateQuoteCoordService.VehicleData.vehicleType !== $scope.rvSupportedVehicleType)//ignore AUTOs to quit from interfering with other panel
                    return;
                var g = args.newguid;
                if (g && $scope.newRVGUID === g)//in case multiple events attempting processing
                    return;
                if (g)
                    $scope.newRVGUID = g;
                $scope.rvInitVehicleData();
                if (!$scope.rvVehicleData.odometer)
                    $scope.rvVehicleData.odometer = 0;

                var whichTab = args.groupIndex;
                if (whichTab != undefined && whichTab > -1) {
                    $rootScope.$broadcast("OPEN-TAB-GROUP", {groupIndex: whichTab});
                }
            });

            $scope.rvInitVehicleData = function(){
                rateQuoteCoordService.clearVehicle();
                quoteInitializationService.initializeVehicleData();
                $scope.rvVehicleData = rateQuoteCoordService.VehicleData;

                if (!$scope.rvVehicleData.dateOfSale || $scope.rvVehicleData.dateOfSale === 'undefined') {
                    $scope.rvVehicleData.dateOfSale = $scope.rvInitializeDate();
                };

                $scope.rvVehicleDefinition.rvType = $scope.rvVehicleData.rvType ? $scope.rvVehicleData.rvType : $scope.valMOTORHOME;
                $scope.rvHoldYear = $scope.rvVehicleData.year;

                if ($scope.rvVehicleData.vin) {
                    $scope.rvVehicleVINChanged($scope.rvVehicleData.vin);
                    //firstQuote = false;
                }
                else { $scope.rvSignalVehicleChanged();}
            }

            $scope.$on(quoteCreationEvents.dealDataChanged, function(event, dealData) {
                $scope.rvVehicleDefinition.dealInfoChanged = true;
            });

            // Parses a date in either mm/dd/yyyy or mm-dd-yyyy format
            function parseMmDdYyyy(date) {
                var splitOn = date.indexOf('/') >= 0 ? '/' : '-';
                var dateSplit = date.split(splitOn);
                return new Date(parseInt(dateSplit[2]),parseInt(dateSplit[0])-1,parseInt(dateSplit[1]));
            }

            //we retrieved an existing quote, so fill in the values for the vehicle
            $scope.$on(quoteCreationEvents.vehicleDataRetrieved, function(event, vehicleArgs) {
                //vehicleArgs in models/vehicle-info.js
                if (rateQuoteCoordService.VehicleData.vehicleType !== $scope.rvSupportedVehicleType)//ignore AUTOs to quit from interfering with other panel
                    return;

                if($scope.rvVehicleData.vehicleUsage) {
                    $scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal = _.isArray($scope.vehicleData.vehicleUsage) ? $scope.vehicleData.vehicleUsage.join(',') : $scope.vehicleData.vehicleUsage;
                }

                $scope.rvVehicleData = rateQuoteCoordService.VehicleData;

                //vin quote or y/m/m??
                if ($scope.rvVehicleData.vin){
                    $scope.rvHoldYear = parseInt($scope.rvVehicleData.year);
                    $scope.rvHoldMake = $scope.rvVehicleData.makeName;
                    $scope.rvHoldModel = $scope.rvVehicleData.modelName;
                    //$scope.rvVehicleData.vin = vehicleArgs.vin;
                    $scope.rvVehicleVINChanged($scope.rvVehicleData.vin);
                    $scope.rvSelectModelYear($scope.rvHoldYear, true);

                    $scope.setMake($scope.rvHoldMake);
                    $scope.setModel($scope.rvHoldModel);
                }else{
                    $scope.rvSelectModelYear($scope.rvVehicleData.year, true);
                    $scope.setMake($scope.rvHoldMake);
                    $scope.setModel($scope.rvHoldModel);
                }
            });
            //set date to today
            $scope.rvInitializeDate = function(){
                var today = new Date();
                return today;
            }
            //get vehicle usages from service
            $scope.rvGetVehicleUsages = function() {
                vehicleDefinitionService.getVehicleUsages()
                .then(
                    function usagesReceived(data) {
                        var usages = data;
                        $scope.rvVehicleDefinition.vehicleUsageSetup.listItems = (usages && usages.length > 0) ? usages : null;
                        $scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal = (usages && usages.length > 0) ? usages[0].vehicleUsage : null;
                        $scope.rvVehicleData.vehicleUsage = (usages && usages.length > 0) ? usages[0].vehicleUsage : null;
                    },
                    function(err) {
                        $scope.rvVehicleDefinition.vehicleUsageSetup.clearItems();
                        $scope.signalVehicleError("Could not get vehicle usages.")
                    });
            }

            $scope.rvGetVehicleVinUsages = function() {
                vehicleDefinitionService.getVehicleVINUsages()
                .then(
                    function usagesReceived(data) {
                        var usages = data.usages;
                        $scope.rvVehicleDefinition.vehicleUsageSetup.listItems = (usages && usages.length > 0) ? usages : null;
                        $scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal = null;
                        if ($scope.rvVehicleData.vehicleUsage) {
                            $scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal = _.isArray($scope.rvVehicleData.vehicleUsage) ? $scope.rvVehicleData.vehicleUsage.join(',') : $scope.rvVehicleData.vehicleUsage;
                        } else {
                            $scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal = null;
                            $scope.rvVehicleData.vehicleUsage = null;
                        }
                        console.log($scope.rvVehicleDefinition.vehicleUsageSetup.listItems);
                    },
                    function(err) {
                        $scope.rvVehicleDefinition.vehicleUsageSetup.clearItems();
                        $scope.signalVehicleError("Could not get vehicle usages.")
                    });
            }
            /*
            $scope.rvVinEntered = function(){
                if (!$scope.rvVehicleData || typeof $scope.rvVehicleData.vin === "undefined")
                    return false;
                return $scope.rvVehicleData.vin.length > 0;
            }
            */
            //get model years from service
            $scope.rvGetVehicleModelYears = function(){
                //if (rateQuoteCoordService.VehicleData.vehicleType !== $scope.rvSupportedVehicleType)//ignore AUTOs to quit from interfering with other panel
                //    return;

                vehicleDefinitionService.getModelYears()
                    .then(
                        function modelYearsReceived(data) {
                            $scope.rvVehicleDefinition.modelYearSetup.listItems = data;
                            if ($scope.rvHoldYear > 0)
                                $scope.rvSelectModelYear($scope.rvHoldYear, true);
                        },
                        function(err) {
                            $scope.rvVehicleDefinition.modelYearSetup.clearItems();
                            $scope.rvSignalVehicleError("Could not get vehicle model years.");
                        });
            }
            //get sale type (NEW/USED) from service
            $scope.rvGetVehicleSaleTypes = function() {
                vehicleDefinitionService.getVehicleSaleTypes()
                    .then(
                        function saleTypesReceived(data) {
                            $scope.rvVehicleDefinition.vehiclePlanTypeSetup.listItems = (data && data.length > 0) ? data : null;
                            $scope.rvVehicleDefinition.vehiclePlanTypeSetup.selectedVal = (data && data.length > 0) ? data[0].vehicleSaleType : null;
                            $scope.rvVehicleData.vehicleSaleType = (data && data.length > 0) ? data[0].vehicleSaleType : null;
                        },
                        function(err) {
                            $scope.rvVehicleDefinition.vehiclePlanTypeSetup.clearItems();
                            $scope.rvSignalVehicleError("Could not get vehicle sale types.")
                        });
            }
            //get vehicle data in scope (for events)
            $scope.rvGetCurrentVehicleInfo = function(){
                $scope.rvVehicleData.makeName = $scope.rvVehicleDefinition.makeName;
                $scope.rvVehicleData.modelName = $scope.rvVehicleDefinition.modelName;
                $scope.rvVehicleData.makeId = $scope.rvVehicleDefinition.makeName;
                $scope.rvVehicleData.modelId = $scope.rvVehicleDefinition.modelName;
                $scope.rvVehicleData.vehicleUsage = ($scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal || '').length == 0 ? [] : $scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal.split(',');
                $scope.rvVehicleData.vehicleCert = null;
                $scope.rvVehicleData.vehicleType = $scope.rvSupportedVehicleType;
                $scope.rvVehicleData.rvType = $scope.rvVehicleDefinition.rvType;

                if ($scope.rvVehicleData.rvType == "TOWABLE"){
                   $scope.rvVehicleData.odometer = 1;
               }

                if ($scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal) {
                    $scope.vehicleData.vehicleUsage = ($scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal || '').length == 0 ? [] : $scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal.split(',');
                }

                rateQuoteCoordService.VehicleData = $scope.rvVehicleData;
            }
            //changing something about the vehicle
            $scope.rvSignalVehicleChanged = function(endRetrieve){

                $scope.rvGetCurrentVehicleInfo();

                $rootScope.$broadcast(quoteCreationEvents.vehicleDataChanged, { vehicleType : $scope.rvSupportedVehicleType });
                vehicleProductsProcessingService.productData.haveProducts = false;
                //if we're not in the process of setting up an existing quote, remove any quotes
                if (!rateQuoteRetrievalCoordService.inQuoteRetrieval())
                    $rootScope.$broadcast(quoteCreationEvents.removeCurrentQuotes,{});

                var model = $scope.rvVehicleData.year;
                var modelOK = false;
                if (isNaN(model)) { modelOK = false;}
                else { modelOK = (parseInt(model) > 0); }

                if ($scope.rvVehicleData.dataReadyToRate() && modelOK) {
                    //the vehicle is ready to quote
                    $scope.rvSignalVehicleDataValid();
                }
                if ($scope.providerUsagesByVin) {
                }
                if (endRetrieve)
                    rateQuoteRetrievalCoordService.endQuoteRetrieval();
            }
            //throw an event when vehicle data is valid
            $scope.rvSignalVehicleDataValid = function(){
                rateQuoteCoordService.getNewGuid(rateQuoteRetrievalCoordService.inQuoteRetrieval())
                    .then(function gotNewGuid(guid) {

                        rateQuoteCoordService.VehicleData = $scope.rvVehicleData;

                        //if we didn't change the DOS from previous, display preferences
                        // should be the same

                        if(!$scope.fabMenu.$invalid) {
                            dealerPreferencesService.getAllProductDisplayPreferences(new Date($scope.rvVehicleData.dateOfSale))
                            .then(
                                function(){
                                    vehicleDefinitionService.vehicleDetailsData.ready = true;
                                    vehicleProductsProcessingService.clearProducts(true);
                                    vehicleProductsProcessingService.GetEligibleProducts();

                                    if ($scope.rvVehicleData.dataReadyToSaveQuote()) {
                                        $rootScope.$broadcast(quoteCreationEvents.attemptQuoteSave, {});
                                    }
                                }
                            )
                        }
                    });
            }
            //vehicle data errors processed here
            $scope.rvSignalVehicleError = function(message) {
                throw new TLCError(new Error(message), AppErrorCodes.VehicleController_VehicleInfoError);
            }

            //VIN has changed, decode it if we can
            $scope.rvVehicleVINChanged = function(vin, endRetrieve, doNotSignalVehicleChange){
                if ($scope.rvVehicleDefinition.prevVIN == vin)
                    return;
                if (vin){
                    vehicleDefinitionService.getModelDetails($scope.rvVehicleData.vin)
                        .then(
                            function modelDetailsReceived(data) {
                                if (typeof(data.Make)!= 'undefined' && data.Model.ModelYear !== 0)
                                {
                                    $scope.rvVehicleDefinition.modelYearSetup.listItems = [{"modelYear" : data.Model.ModelYear > 0 ? data.Model.ModelYear : ""}];//set the model year
                                    $scope.rvSelectModelYear(data.Model.ModelYear, false);
                                    $scope.setMake(data.Make.MakeName);
                                    $scope.setModel(data.Model && data.Model.PartnerModelName ? data.Model.PartnerModelName : '');
                                }
                                if (!doNotSignalVehicleChange) {
                                    $scope.rvSignalVehicleChanged(endRetrieve);
                                }
                            },
                            function(err) {
                                $scope.rvSignalVehicleError("Could not decode vehicle VIN.")
                            });
                }
                else{
                    $scope.rvVehicleData.vin = undefined;
                    $scope.rvVehicleDefinition.vehicleModels = [];
                    //if ($scope.vinDecoding) {
                        $scope.rvGetVehicleModelYears();
                   // }
                    if (!doNotSignalVehicleChange) {
                        $scope.rvSignalVehicleChanged(endRetrieve);
                    }
                }
            }
            //selected model year has changed
            $scope.rvSelectModelYear = function(mYear, reload, endRetrieve){
                if (!mYear){
                    return;
                }
                $scope.rvVehicleDefinition.modelYearSetup.selectedItem = $scope.rvVehicleDefinition.modelYearSetup.listItems.filter(function(val) { return val.modelYear == mYear })[0];
                $scope.rvVehicleData.year = mYear;
                hasVehicleChanged();
            }
            //is VIN data being entered?
            $scope.rvVinEntered = function(){
                if (!$scope.rvVehicleData || typeof $scope.rvVehicleData.vin === "undefined")
                    return false;
                return $scope.rvVehicleData.vin.length > 0;
            }

            //keeps user from entering anything bigger than 999999
            $scope.rvOdometerEntered = function(){
                if ($scope.rvVehicleData.odometer && $scope.rvVehicleData.odometer.toString().length >8)
                    $scope.rvVehicleData.odometer = parseInt($scope.rvVehicleData.odometer.toString().slice(0,8));
            }

            $scope.rvOdometerBlur = function () {
            }

            $scope.rvDosChanged = function(){
                hasVehicleChanged();
            }

            $scope.rvInserviceChanged = function () {
                hasVehicleChanged();
            }

            $scope.rvManuMonthsBlur = function() {
                hasVehicleChanged();
            }

            $scope.rvManuMilesBlur = function () {
                hasVehicleChanged();
            }

            $scope.rvUsageChanged = function () {
                hasVehicleChanged();
            }

            //init the settings
            quoteInitializationService.initializeVehicleData();
            $scope.rvInitializeDetails();

            // Determines if the Vehicle information has changed.
            function hasVehicleChanged() {
                var vehInfoChanged = false;
                var curUsage;
                var lastUsage;
                if (angular.isArray($scope.vehicleData.vehicleUsage)) {
                    curUsage = ($scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal || '').toUpperCase();
                    lastUsage = ($scope.rvVehicleDefinition.prevUsage || []).join(',').toUpperCase();
                } else {
                    curUsage = ($scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal || '').toUpperCase();
                    lastUsage = ($scope.rvVehicleDefinition.prevUsage || '').toString().toUpperCase();
                }
                if ($scope.rvVehicleData.vin != $scope.rvVehicleDefinition.prevVIN ||
                    $scope.rvVehicleData.year != $scope.rvVehicleDefinition.prevyear ||
                    $scope.rvVehicleData.makeId != $scope.rvVehicleDefinition.prevmakeId ||
                    $scope.rvVehicleData.modelId != $scope.rvVehicleDefinition.prevmodelId ||
                    $scope.rvVehicleData.odometer != $scope.rvVehicleDefinition.prevOdometer ||
                    $scope.rvVehicleData.dateOfSale != $scope.rvVehicleDefinition.prevDateOfSale ||
                    $scope.rvVehicleData.inService != $scope.rvVehicleDefinition.prevInService ||
                    //$scope.rvVehicleDefinition.dealInfoChanged ||
                    $scope.rvVehicleData.rvType != $scope.rvVehicleDefinition.prevRVType ||
                    $scope.rvVehicleData.rvManuMiles!= $scope.rvVehicleDefinition.prevManuMiles ||
                    $scope.rvVehicleData.rvManuMonths != $scope.rvVehicleDefinition.prevManuMonths ||
                    curUsage != lastUsage
                ) {
                    vehInfoChanged = true;
                    vehicleProductsProcessingService.setVehicleInfoDataChanged(vehInfoChanged);
                    return vehInfoChanged;
                }
                vehicleProductsProcessingService.setVehicleInfoDataChanged(vehInfoChanged);
                return vehInfoChanged;
            }

            $scope.setMake = function(makeName){
                $scope.rvVehicleDefinition.makeName = makeName;
                $scope.rvVehicleData.makeName = makeName;
                $scope.rvVehicleData.makeId = makeName;
            }

            $scope.setModel = function(modelName){
                $scope.rvVehicleDefinition.modelName = modelName;
                $scope.rvVehicleData.modelName = modelName;
                $scope.rvVehicleData.modelId = modelName;
            }

            $scope.$on(tuxFabMenuEvents.closed, function () {
                if ($scope.rvVehicleData.vehicleType !== $scope.rvSupportedVehicleType)
                    return;//don't care if not an RV
                var vehicleChanged = hasVehicleChanged();
                //$scope.rvVehicleDefinition.dealInfoChanged = false;//reset when we close the FAB menu
                $window.sessionStorage.setItem('SESS_VEHICLE_CHANGED', JSON.stringify(vehicleChanged));
            });

            $scope.$on(quoteCreationEvents.vechicleDataChangedProceed, function(event, signal){
                if ($scope.rvVehicleData.vehicleType !== $scope.rvSupportedVehicleType || $window.sessionStorage.getItem('SESS_VEHICLE_CHANGED')==null)
                    return;//don't care if not an RV
                //clearing the items in storage for future use (prevents multiple calls)
                if (!$scope.rvVehicleData.vin)
                    $scope.rvVehicleData.vin = null;
                
                $window.sessionStorage.removeItem('SESS_VEHICLE_CHANGED');
                if (signal)
                    $scope.rvSignalVehicleChanged(true);
            });

            $scope.rvToggleVehicleUsage = function(usage){
                rateQuoteRetrievalCoordService.endQuoteRetrieval();
                $scope.rvGetCurrentVehicleInfo()
            }

            // Saves initial Vehicle definition values.
            $scope.$on(tuxFabMenuEvents.shown, function (evt, arg) {
                $scope.rvCheckVehicleChangeRV(arg);
                $scope.rvVehicleDefinition.dealInfoChanged = false;//reset when we close the FAB menu
                $scope.rvCapturePreviousValues();
            });

            $scope.$on(tuxFabMenuEvents.changeVehicle, function (evt, arg) {
                $scope.rvCheckVehicleChangeRV(arg);
            });

            $scope.rvCheckVehicleChangeRV = function(fabGroup){
                if (fabGroup === 0 && $scope.rvVehicleData.vehicleType !== $scope.rvSupportedVehicleType){
                    $scope.rvVehicleData.clearVehicle();
                    $scope.rvVehicleData.vehicleType = $scope.rvSupportedVehicleType;
                }else if (fabGroup === 1) {$scope.rvVehicleData.vehicleType = null; }
            }


            $scope.rvCheckDateValidity = function()
            {
                if($scope.fabMenu.RVinDateOfSale.$error.valid)
                {
                    return "Invalid format date";
                }
                return "Invalid sale date";

            }

            $scope.rvCapturePreviousValues = function(){
                $scope.rvVehicleDefinition.prevVIN = $scope.rvVehicleData.vin;
                $scope.rvVehicleDefinition.prevOdometer = $scope.rvVehicleData.odometer;
                $scope.rvVehicleDefinition.prevDateOfSale = $scope.rvVehicleData.dateOfSale;
                $scope.rvVehicleDefinition.prevInService = $scope.rvVehicleData.inService;
                $scope.rvVehicleDefinition.prevyear = $scope.rvVehicleData.year;
                $scope.rvVehicleDefinition.prevmakeId = $scope.rvVehicleData.makeId;
                $scope.rvVehicleDefinition.prevmodelId = $scope.rvVehicleData.modelId;
                $scope.rvVehicleDefinition.prevRVType = $scope.rvVehicleData.rvType;
                $scope.rvVehicleDefinition.prevManuMiles = $scope.rvVehicleData.rvManuMiles;
                $scope.rvVehicleDefinition.prevManuMonths = $scope.rvVehicleData.rvManuMonths;
                $scope.rvVehicleDefinition.prevUsage = _.clone($scope.rvVehicleData.vehicleUsage);
            };

            $scope.rvToggleVehicleUsageChecked = function(code) {
                var current = $scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal || '';
                if (current.indexOf(code) > -1) { current = current.replace(code + ',', '').replace(code, ''); }
                else { current = (current || '').length > 0 ? current + ',' + code : code; }
                $scope.rvVehicleDefinition.vehicleUsageSetup.selectedVal = current;
                hasVehicleChanged();
            }
        }]);
